import { Component, OnInit } from '@angular/core';
import { AmplifyService } from '../aws/amplify.service';
import { MatTab, MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-newpiperdiver',
  templateUrl: './newpiperdiver.component.html',
  styleUrls: ['./newpiperdiver.component.css'],
  imports: [MatTabGroup, MatTab],
  standalone: true
})
export class NewpiperdiverComponent implements OnInit {
  uploadMessage: string = '';
  selectedFiles: FileList;
  constructor(private amplifyService: AmplifyService) {}

  ngOnInit(): void {}

  async upload() {
    const file = this.selectedFiles.item(0);
    const fileName = `angular-app/input/${file.name}`;

    try {
      const result = await this.amplifyService.uploadFileToS3(
        fileName,
        file,
        'piperdiverBucket'
      );
      console.log('File uploaded successfully', result);
      this.uploadMessage = 'File uploaded successfully!';
    } catch (error) {
      console.error('Error uploading file', error);
      this.uploadMessage = 'Error on uploading file.';
    }
  }

  selectFile(event: any) {
    this.selectedFiles = event.target.files;
  }
}
